import {UI} from "../../../../../../../stem-core/src/ui/UIBase.js";
import {ensure} from "../../../../../../../stem-core/src/base/Require.js";

const PAYPAL_BUTTON_ID = "paypal-button-container";

function MakePayPalSDKURL(clientId) {
    const disableFunding = "card,credit,paylater,bancontact,blik,eps,giropay,ideal,mercadopago,mybank,p24,sepa,sofort,venmo";
    return `https://www.paypal.com/sdk/js?client-id=${clientId}&components=buttons&intent=authorize&commit=false&disable-funding=${disableFunding}&integration-date=2022-07-07&vault=true`;
}


export class PayPalWidget extends UI.Element {
    render() {
        return [
            <div id={PAYPAL_BUTTON_ID} style={{height: 42}} />,
        ]
    }

    insertButtons() {
        this.orderData = null;
        window.paypal.Buttons({
            style: {
                layout: "horizontal",
                color: "white",
                shape: "rect",
                label: "paypal",
                tagline: false,
                height: 42,
            },
            // createOrder: (data, actions) => {
            //     console.warn("createOrder", data, actions);
            //
            //     return actions.order.create({
            //         intent: "AUTHORIZE",
            //         purchase_units: [{
            //             amount: {
            //                 value: "20.00"
            //             }
            //         }],
            //         // As seen here: https://developer.paypal.com/docs/api/orders/v2/#definition-application_context
            //         application_context: {
            //             brand_name: "The New Republic",
            //             shipping_preference: "NO_SHIPPING", // TODO could also be SET_PROVIDED_ADDRESS
            //             user_action: "CONTINUE",
            //         }
            //     });
            // },
            onApprove: (data, actions) => {
                // console.warn("onApprove", data, actions);
                const {onApprove} = this.options;
                onApprove(data, actions);
            }
        }).render("#" + PAYPAL_BUTTON_ID);
    }

    onMount() {
        const {paymentProcessor} = this.options;
        const paypalClientId = paymentProcessor.publicKey;
        const paypalURL = MakePayPalSDKURL(paypalClientId);

        ensure(paypalURL, () => {
            this.insertButtons();
        });
    }
}
